import { Stack, Text, Tooltip } from "@mantine/core"
import { Missing, useTextOverflow } from "@tfg/ui"
import { ReactNode } from "react"

type Props = {
  label: string
  value?: string | ReactNode | null
  w?: number
}

export const PropertyItemInfo = ({ label, value, w }: Props) => {
  const { isOverflowing, textRef } = useTextOverflow()
  return (
    <Stack gap={1} w={w} align="flex-start">
      <Text fw={400}>{label}</Text>
      {isOverflowing ? (
        <Tooltip label={value}>
          <Text ta="right" maw="100%" fw={600} ref={textRef} truncate>
            {value}
          </Text>
        </Tooltip>
      ) : value ? (
        <Text ta="right" fw={600} ref={textRef} truncate maw="100%">
          {value}
        </Text>
      ) : (
        <Missing />
      )}
    </Stack>
  )
}
